import { useLayoutEffect } from 'react';
import { settingsSelectors } from '../../app/resource/settings/settings.selectors';
import { useSelect } from '../../utils/selector.utils';
import Cookies from 'js-cookie';

/**
 * Applies the tenant theme color. Cookie is used until settings load so the
 * color is available on first paint.
 */
export const ThemeInjector = () => {
  const primaryColor = useSelect(settingsSelectors.selectCurrentSettings)?.primaryColor1;

  useLayoutEffect(() => {
    const color = primaryColor || Cookies.get('color_theme');
    if (!color) {
      return;
    }

    document.documentElement.style.setProperty('--theme-primary-color', color);
    if (primaryColor) {
      Cookies.set('color_theme', primaryColor);
    }
  }, [primaryColor]);

  return null;
};
